import router from '@/router/index';
import userService from "@/api/SAASUserService";
import zoneService from '@/api/zoneService';


const state = {
    user: [],
    editId: null,
    newUser: "",
    roles: [],
    zones: [],
    clientsData: [],
    client:{},
    clientId: null,
}
const getters = {
    userList: state => state.user,
    newUser: state => state.newUser,
    roleList: state => state.roles,
    zoneList: state => state.zones
}
const actions = {
    async roleList({ commit }) {
        const response = await userService.roleList();
        commit('roleList', response.data.result)
    },
    async getZones({ commit }) {
        const response = await zoneService.getZone()
        commit('getZones', response.data.result)
    },
    async userList({ commit }) {
        const response = await userService.userList();
        commit('userList', response.data.result)
    },
    async removeUser({ commit }, user) {
        await userService.removeUser(user.id)
        commit('remove', user)
    },
    async editUser({ commit }, user) {
        await userService.editUser(user.id)
        commit('edit', user)
    },
    async addUsers({ commit }, userData) {
        await userService.addUsers(userData)
        commit('addUsers', userData)
    },
    async updateUser({ commit }, userData) {
        await userService.updateUser(state.editId, userData)
        commit('update', userData)
    },
    async searchUser({ commit }, word) {
        const response = await userService.userList();
        const search = word.trim().toLowerCase()
        let list
        if (!search.length) {
            list = response.data.result;
        } else {
            list = response.data.result.filter(item => item.userName.toLowerCase().indexOf(search) > -1)
        }
        commit('userList', list)
    },
    async addClients({ commit, rootState }, clientData) {
        const response = await userService.addClient(clientData);
        if(response.result) {
        rootState.clients.push(response.result);
        state.clientsData = rootState.clients;
        }
        commit('addClient', state.clientsData)
    },
    async updateClient({ commit, rootState }, clientData) {
        const response = await userService.updateClient(clientData);
        if(response.result) {
        const index = rootState.clients.map(item => item.id).indexOf(clientData.id)
        rootState.clients[index] = clientData;
        state.clientsData = rootState.clients;
        }
        commit('addClient', state.clientsData)
    },
    async editClient({ commit }, client) {
        let clientId = client.id;
        commit('editClient', client, clientId)
    },
    
}
const mutations = {
    roleList(state, roles) {
        state.roles = roles
    },
    getZones(state, zone){
        state.zones= zone
    },
    userList(state, users) {
        state.user = users
    },
    addUsers(state, users) {
        state.user.push(users);
    },
    remove(state, user) {
        var users = state.user
        const index = users.map(item => item.id).indexOf(user.id)
        users.splice(index, 1)
    },
    edit(state, user) {
        state.editId = user.id
        state.newUser = user
        router.push({ name: "AddUser", params: { add: false } });
    },
    update(state, userData) {
        const index = state.user.map(item => item.name).indexOf(userData.name)
        state.user[index] = userData;
    },
    addClient(state,clientsData) {
        state.clientsData = clientsData;
    },
    editClient(state, client, id) {
        state.clientId = id;
        state.client = client;
        router.push({ name: "AddClient", params: { add: false } });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}




